<template>
  <div />
</template>

<script setup>
import { useRouter } from 'vue-router';

import { useAuthStore } from '@/stores/auth';

const authStore = useAuthStore()
const router = useRouter();

if(authStore.canManageAuction) {
  router.push('/aste');
} else if(authStore.canManagePlatform) {
  router.push('/prodotti');
} else if(authStore.canManageUser) {
  router.push('/utenti');
} else if(authStore.canManageAdmin) {
  router.push('/amministratori');
}

</script>